import { TaskName } from '@/common/constants/taskNames.constants';
import { TaskState } from '@schema';
import i18n from '@/common/i18n';
import type { TaskMap } from '@/common/store/modules/tasks/tasksNotificationMapper';

const taskMap: TaskMap = {
  [TaskName.NETWORK_INTERFACE_VLAN_CREATE]: {
    [TaskState.SUCCESS]: () => ({
      title: i18n.t('VLAN created'),
      message: i18n.t('VLAN successfully created'),
    }),
    [TaskState.RUNNING]: () => ({
      message: i18n.t('Creating VLAN interface...'),
    }),
    [TaskState.FAILED]: ({ error }) => ({
      title: i18n.t('Error creating VLAN interface'),
      message: error
    })
  },
  [TaskName.NETWORK_INTERFACE_UPDATE]: {
    [TaskState.SUCCESS]: ({ pathVariables }) => {
      const [_nodeId, ifaceName] = pathVariables || [];

      return {
        title: i18n.t('Network interface updated'),
        message: i18n.t('Network interface "{0}" successfully updated', [ifaceName])
      };
    },
    [TaskState.RUNNING]: ({ pathVariables }) => {
      const [_nodeId, ifaceName] = pathVariables || [];

      return {
        message: i18n.t('Updating network interface "{0}"...', [ifaceName])
      };
    },
    [TaskState.FAILED]: ({ error, pathVariables }) => {
      const [_nodeId, ifaceName] = pathVariables || [];

      return {
        title: i18n.t('Error updating network interface "{0}"', [ifaceName]),
        message: error
      };
    }
  },
  [TaskName.NETWORK_INTERFACE_DOWN]: {
    [TaskState.SUCCESS]: ({ pathVariables }) => {
      const [_nodeId, ifaceName] = pathVariables || [];

      return {
        title: i18n.t('Network interface disabled'),
        message: i18n.t('Network interface "{0}" successfully disabled', [ifaceName])
      };
    },
    [TaskState.RUNNING]: ({ pathVariables }) => {
      const [_nodeId, ifaceName] = pathVariables || [];

      return {
        message: i18n.t('Bringing down network interface "{0}"...', [ifaceName])
      };
    },
    [TaskState.FAILED]: ({ error, pathVariables }) => {
      const [_nodeId, ifaceName] = pathVariables || [];

      return {
        title: i18n.t('Error bringing down interface "{0}"', [ifaceName]),
        message: error
      };
    }
  },
  [TaskName.NETWORK_INTERFACE_UP]: {
    [TaskState.SUCCESS]: ({ pathVariables }) => {
      const [_nodeId, ifaceName] = pathVariables || [];

      return {
        title: i18n.t('Network interface enabled'),
        message: i18n.t('Network interface "{0}" successfully enabled', [ifaceName])
      };
    },
    [TaskState.RUNNING]: ({ pathVariables }) => {
      const [_nodeId, ifaceName] = pathVariables || [];

      return {
        message: i18n.t('Bringing up network interface "{0}"...', [ifaceName])
      };
    },
    [TaskState.FAILED]: ({ error, pathVariables }) => {
      const [_nodeId, ifaceName] = pathVariables || [];

      return {
        title: i18n.t('Error bringing up interface "{0}"', [ifaceName]),
        message: error
      };
    }
  },
  [TaskName.NETWORK_INTERFACE_BOND_CREATE]: {
    [TaskState.SUCCESS]: () => ({
      title: i18n.t('Bond created'),
      message: i18n.t('Bond successfully created'),
    }),
    [TaskState.RUNNING]: () => ({
      message: i18n.t('Bonding interfaces...'),
    }),
    [TaskState.FAILED]: ({ error }) => ({
      title: i18n.t('Error bonding interfaces'),
      message: error
    })
  }
};

export default taskMap;
